<div *ngIf="promo == 'unhideweek'" class="promo-banner">
  <div class="promo-banner-content">
    <div class="cta-wrapper">
      <button
        mat-button
        class="unhideweek-cta-promo unh-button-old"
        [attr.theme]="banner.btntheme"
        routerLink="assinatura/planos-e-precos"
      >
        <span style="margin-top: 4px">QUERO APROVEITAR</span>
      </button>
    </div>
  </div>
</div>

<div *ngIf="promo == 'jornadailustrador'" class="promo-banner">
  <div class="promo-banner-content">
    <div class="group-container">
      <div class="text-container">
        <img [src]="banner.textpromo" alt="" />

        <button
          mat-button
          class="unhideweek-cta-promo unh-button-old desktop"
          [attr.theme]="banner.btntheme"
          [routerLink]="banner.btnlink"
        >
          <span>QUERO APROVEITAR</span>
        </button>
      </div>

      <div class="img-container">
        <img [src]="banner.imgpromo" alt="" />
      </div>
    </div>

    <button
      mat-button
      class="unhideweek-cta-promo unh-button-old mobile"
      [attr.theme]="banner.btntheme"
      [routerLink]="banner.btnlink"
    >
      <span>QUERO APROVEITAR</span>
    </button>
  </div>
</div>
